export default "__VITE_ASSET__Cqqgopft__"